/**
 * Cordova plugin opens link an in-app browser window.
 * Reference docs used to derive types & behavior:
 *   https://www.npmjs.com/package/cordova-plugin-inappbrowser
 */

import { useUserStore } from "@/shared/store/user";
import { AppBrowserTarget } from "./types";

class InAppBrowser {
  private get plugin (): any {
    return (window as any).cordova.InAppBrowser;
  }

  /**
   * @param url string
   * @param target enum: AppBrowserTarget
   * @param options(optional) string. Example: "location=yes,hideurlbar=yes,toolbarposition=top,fullscreen=no".
   * For more information: https://cordova.apache.org/docs/en/10.x/reference/cordova-plugin-inappbrowser/
   */
  openUrl (url: string, target: AppBrowserTarget, options = ""): void {
    const inAppBrowserRef = this.plugin.open(url, target, options);

    // event fires when the InAppBrowser finishes loading a URL
    inAppBrowserRef.addEventListener("loadstop", loaded);
    // event fires when the InAppBrowser window is closed.
    inAppBrowserRef.addEventListener("exit", exited);

    function loaded () {
      const userStore = useUserStore();
      userStore.activeUserPing();
    }

    function exited () {
      inAppBrowserRef.removeEventListener("loadstop", loaded);
      inAppBrowserRef.removeEventListener("exit", exited);
    }
  }
}

export default new InAppBrowser();